import { Component, OnInit } from '@angular/core';
import { tabs } from 'src/app/dummy/tabs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AddGeoDistrictComponent } from '../add-geo-district/add-geo-district.component';
import { DataService } from 'src/app/services/data.service';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-geo-district',
  templateUrl: './geo-district.component.html',
  styleUrls: ['./geo-district.component.scss']
})
export class GeoDistrictComponent implements OnInit {
  tabs = tabs.GEO

  constructor(
    private router: Router,
    public store: List,
    private ds:DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddGeoDistrictComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.districtRef(ref => ref.orderBy("code")))
  }

  ngOnDestroy() {
    this.store.dispost();
  }



}
